export default __webpack_public_path__ + "static/media/thumbs-up-icon.07658e81.svg";